// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__Xq6iY","selected":"Chip_selected__b5tIH"};